import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What credit score do I need to rent?',
      answer: 'We work with tenants across various credit profiles. While we do conduct credit checks, we consider the full picture including income, rental history, and references. Even if your credit isn\'t perfect, we encourage you to apply—we may still be able to work with you.'
    },
    {
      question: 'How much do I need for move-in costs?',
      answer: 'Typically, move-in costs include the first month\'s rent and a security deposit (usually equal to one month\'s rent). Some properties may have additional fees. We\'ll provide a complete breakdown of all costs before you commit.'
    },
    {
      question: 'Are pets allowed?',
      answer: 'Many of our properties are pet-friendly! Pet policies vary by property and may include pet deposits or monthly pet rent. Let us know about your furry friends when you join the waitlist, and we\'ll match you with pet-friendly options.'
    },
    {
      question: 'How long does the application process take?',
      answer: 'Once you submit a complete application, we typically provide a decision within 24-48 hours. The entire process from application to move-in usually takes 1-2 weeks, depending on your move-in date preference.'
    },
    {
      question: 'What documents do I need to apply?',
      answer: 'You\'ll need: valid photo ID, proof of income (pay stubs or bank statements), rental history/references, and employment verification. We\'ll provide a complete checklist when you\'re ready to apply.'
    },
    {
      question: 'Can I view properties before applying?',
      answer: 'Absolutely! Once we have properties that match your criteria, we\'ll schedule viewings at times convenient for you. We want you to see your potential new home before making any commitments.'
    },
    {
      question: 'What if I need to break my lease early?',
      answer: 'We understand that circumstances change. Our lease agreements include clear terms regarding early termination. We work with tenants to find solutions when unexpected situations arise.'
    },
    {
      question: 'How quickly are maintenance requests handled?',
      answer: 'Emergency maintenance requests are addressed immediately. Non-emergency requests are typically handled within 2-5 business days. We have a dedicated maintenance team to ensure your home stays in great condition.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-700">
            Got questions? We've got answers. Here are the most common questions we receive from prospective tenants.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
